import { QueryStatus } from 'src/types'
import { Instrumento } from '../api/get-instrumentos'
import { useEffect, useState } from 'react'
import { HttpWRM } from '../api'

export const useInstrumentos = (idOperacion: number) => {
    const [instrumentos, setInstrumentos] = useState<Instrumento[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpWRM.getInstrumentos(idOperacion)
            .then(value => {
                setInstrumentos(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }

    const refetch = () => fetch()

    const deleteInstrumento = (idOperationDetail: number) => {
        HttpWRM.deleteInstrumento(idOperacion, idOperationDetail).then(() => {
            fetch()
        })
    }

    useEffect(() => {
        fetch()
    }, [idOperacion])

    return { instrumentos, refetch, status, deleteInstrumento }
}
